import React from 'react';
import { Global, css } from '@emotion/react';

import Lato from '../assets/fonts/lume/Lato-Normal.woff';
import Lato2 from '../assets/fonts/lume/Lato-Normal.woff2';
import LatoLight from '../assets/fonts/lume/Lato-Light.woff';
import Poppins from '../assets/fonts/lume/Poppins-Regular.woff';
import PoppinsSemiBold from '../assets/fonts/lume/Poppins-SemiBold.woff';
import PoppinsBold from '../assets/fonts/lume/Poppins-Bold.woff';
import PoppinsBlackHeavy from '../assets/fonts/lume/Poppins-BlackHeavy.woff2';

const GlobalStyle = () => {
  const styles = css`

    @font-face {
      font-display: swap;
      font-family: 'Lato';
      src: url(${Lato2}) format('woff2'), url(${Lato}) format('woff');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'Lato-Light';
      src: url(${LatoLight}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Poppins';
      src: url(${Poppins}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Poppins-SemiBold';
      src: url(${PoppinsSemiBold}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Poppins-Bold';
      src: url(${PoppinsBold}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Poppins-BlackHeavy';
      src: url(${PoppinsBlackHeavy}) format('woff2');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }
  `;

  return <Global styles={styles} />;
};

export default GlobalStyle;
